<template>
  <ul id="mpn-list" class="mpn-list">
    <component :is="currentItemComponent" 
      v-for="(item, i) in products" 
      :product="item" 
      :key="i" 
    />
  </ul>
</template>

<script>
import ProductListItem from './ProductListItem.vue';
import ProductListItemDetail from './ProductListItemDetail.vue';

export default {
  name: 'ProductList',

  props: ['products', 'currentItemComponent'],

  components: {
    'product-item': ProductListItem, 
    'product-item-detail': ProductListItemDetail
  } //components

} //export
</script>

<style scoped>
  .product-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    margin: 10px 5%;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/ProductList.vue